/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleMetadataTaskCompletionMinLevelsAnyOf } from './moduleMetadataTaskCompletionMinLevelsAnyOf';

export type ModuleMetadataTaskCompletionMinLevels = ModuleMetadataTaskCompletionMinLevelsAnyOf | null;
